var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreesOnLot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 20",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8451 15.2314L12.7149 12.4932C12.4034 12.2213 12.5913 11.7129 13.0076 11.7021C13.4239 11.6928 13.8339 11.682 14.2753 11.648C14.6634 11.6186 14.8419 11.1566 14.5711 10.8816L12.7102 8.99482C12.4441 8.72595 12.6085 8.27165 12.9872 8.22993C13.366 8.18821 13.5303 7.73391 13.2642 7.46504L10.8477 5.02511C10.577 4.7516 10.7507 4.29267 11.1357 4.25867C11.2218 4.25095 11.311 4.24322 11.4002 4.23395C11.7821 4.19377 11.948 3.73638 11.6788 3.46751L8.27001 0.0417214C8.21524 -0.0139071 7.7864 -0.0139071 7.73006 0.0417214L4.32127 3.46751C4.05207 3.73793 4.21954 4.19377 4.59986 4.23395C4.69063 4.24322 4.77828 4.25249 4.86436 4.25867C5.24937 4.29267 5.4231 4.7516 5.15234 5.02511L2.73583 7.46504C2.46976 7.73391 2.63253 8.18821 3.01285 8.22993C3.3916 8.27165 3.55594 8.72595 3.28987 8.99482L1.42897 10.8816C1.15664 11.1566 1.33663 11.6186 1.72477 11.648C2.16613 11.682 2.57619 11.6913 2.9925 11.7021C3.40882 11.7114 3.59663 12.2197 3.28518 12.4932L0.154979 15.2314C-0.15804 15.5049 0.0344669 16.0164 0.452348 16.0226L6.52649 16.0983C6.77535 16.1014 6.97568 16.2992 6.97881 16.5449L7.01324 19.5534C7.01637 19.8022 7.2214 20.0015 7.47338 20L7.99769 19.9969L8.522 20C8.77398 20.0015 8.98057 19.8022 8.98213 19.5534L9.01657 16.5449C9.0197 16.2992 9.22003 16.1014 9.46888 16.0983L15.543 16.0226C15.9609 16.0179 16.155 15.5065 15.8404 15.2314H15.8451Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_221"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreesOnLot);
export default __webpack_public_path__ + "static/media/trees-on-lot.611d2aff65c8405586bb45ed61f12f4d.svg";
export { ForwardRef as ReactComponent };